export default __webpack_public_path__ + "static/image1-b3ccecf4bfd5e0ed1f11dea055775e86.gif";